// extracted by mini-css-extract-plugin
module.exports = {"boton_p":"ChartSwitcher__boton_p__1Veg"};